<template>
  <div>
    <div class="shareholder" style="display: flex;">

      <a-card style="margin-top: 10px; width: 50%;">
        <div style="margin-top: -10px; margin-bottom: 10px; font-weight: bold;">Frisk-rating评分转换规则</div>
        <a-row :gutter="20" style="">
          <a-col>
            <div>
              <div style=" width: calc(200%); display: flex;">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">外部评级</span>
                  </a-col>
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      内部等级
                    </span>
                  </a-col>
                  <a-col :span="2" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">操作</span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; width: calc(220%);"
              v-for="(item, index) in friskForm"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question">
                <div v-if="index == 0" style="height: 5px;"></div>
                <a-row :gutter="5" >
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="item.maxLevel"
                          :step="1"
                          max="10000" min="0"
                          style="width: 200px; height: 30px"
                          :disabled="friskEdit"
                          prop="item.maxLevel"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-select
                          placeholder="请选择等级"
                          v-model="item.creditLevel"
                          style="width: 200px; height: 30px"
                          :disabled="friskEdit"
                        >
                          <a-select-option
                            v-for="item in objectList"
                            :value="item.text"
                            :key="item.text"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" style="margin-left: -30px; margin-top: 10px">
                    <a-tooltip placement="topLeft">
                      <img
                        src="./images/add.png"
                        style="width: 20px; height: 20px"
                        @click="addFrisk"
                        v-if="!friskEdit"
                      />
                    </a-tooltip>
                    <a-tooltip placement="topLeft" style="margin-left: 10px">
                      <img
                        src="./images/delete.png"
                        style="width: 20px; height: 20px; margin-top: -1px"
                        @click="removeFrisk(item)"
                        v-if="index != 0 && friskEdit == false"
                      />
                    </a-tooltip>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
        </a-row>
        <div style="margin-top: 10px, margin-left: 300px,">
            <a-button @click="handleSubmitSetting(friskForm,1)" v-if="!friskEdit">
                提交
            </a-button>
            <a-button @click="handleFriskEdit" v-else>
                编辑
            </a-button>
        </div>
      </a-card>

      <a-card style="margin-top: 10px; width: 50%">
        <div style="margin-top: -10px; margin-bottom: 10px; font-weight: bold;">Fitch(惠誉)评分转换规则</div>
        <a-row :gutter="20">
          <a-col>
            <div>
              <div style="width: calc(200%);">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">外部评级</span>
                  </a-col>
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      内部等级
                    </span>
                  </a-col>
                  <a-col :span="2" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">操作</span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; width: calc(220%);"
              v-for="(scoreResult, index) in fitchForm"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question" >
                <div v-if="index == 0" style="height: 5px;"></div>
                <a-row :gutter="5">
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input
                          controls-position="right"
                          v-model="scoreResult.maxLevel"
                          :step="1"
                          :max-length="20"
                          style="width: 200px; height: 30px"
                          :disabled="fitchEdit"
                          type="text"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-select
                          placeholder="请选择等级"
                          v-model="scoreResult.creditLevel"
                          style="width: 200px; height: 30px"
                          :disabled="fitchEdit"
                        >
                          <a-select-option
                            v-for="item in objectList"
                            :value="item.text"
                            :key="item.text"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" style="margin-left: -30px; margin-top: 10px">
                    <a-tooltip placement="topLeft">
                      <img
                        src="./images/add.png"
                        style="width: 20px; height: 20px"
                        @click="addFitch"
                        v-if="!fitchEdit"
                      />
                    </a-tooltip>
                    <a-tooltip placement="topLeft" style="margin-left: 10px">
                      <img
                        src="./images/delete.png"
                        style="width: 20px; height: 20px; margin-top: -1px"
                        @click="removeFitch(scoreResult)"
                        v-if="index != 0 && fitchEdit == false"
                      />
                    </a-tooltip>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
        </a-row>
        <div style="margin-top: 10px, margin-left: 300px, right: 0">
            <a-button @click="handleSubmitSetting(fitchForm,3)"  v-if="!fitchEdit">
                提交
            </a-button>
            <a-button @click="handleFitchEdit" v-else>
                编辑
            </a-button>
        </div>
      </a-card>
    </div>

    <div class="shareholder" style="display: flex;">
      <a-card style="margin-top: 10px; width: 50%;">
        <div style="margin-top: -10px; margin-bottom: 10px; font-weight: bold;">Moody's评分转换规则</div>
        <a-row :gutter="20">
          <a-col>
            <div>
              <div style=" width: calc(200%); ">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">外部评级</span>
                  </a-col>
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      内部等级
                    </span>
                  </a-col>
                  <a-col :span="2" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">操作</span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; width: calc(220%);"
              v-for="(scoreResult, index) in moodyForm"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question" >
                <div v-if="index == 0" style="height: 5px;"></div>
                <a-row :gutter="5">
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input
                          controls-position="right"
                          v-model="scoreResult.maxLevel"
                          :step="1"
                          :max-length="20"
                          style="width: 200px; height: 30px"
                          :disabled="moodyEdit"
                          type="text"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-select
                          placeholder="请选择等级"
                          v-model="scoreResult.creditLevel"
                          style="width: 200px; height: 30px"
                          :disabled="moodyEdit"
                        >
                          <a-select-option
                            v-for="item in objectList"
                            :value="item.text"
                            :key="item.text"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" style="margin-left: -30px; margin-top: 10px">
                    <a-tooltip placement="topLeft">
                      <img
                        src="./images/add.png"
                        style="width: 20px; height: 20px"
                        @click="addMoody"
                        v-if="!moodyEdit"
                      />
                    </a-tooltip>
                    <a-tooltip placement="topLeft" style="margin-left: 10px">
                      <img
                        src="./images/delete.png"
                        style="width: 20px; height: 20px; margin-top: -1px"
                        @click="removeMoody(scoreResult)"
                        v-if="index != 0 && moodyEdit == false"
                      />
                    </a-tooltip>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
        </a-row>
        <div style="margin-top: 10px, margin-left: 300px,">
            <a-button @click="handleSubmitSetting(moodyForm,4)" v-if="!moodyEdit">
                提交
            </a-button>
            <a-button @click="handleMoodyEdit" v-else>
                编辑
            </a-button>
        </div>
      </a-card>

      <a-card style="margin-top: 10px; width: 50%">
        <div style="margin-top: -10px; margin-bottom: 10px; font-weight: bold;">ww评分转换规则</div>
        <a-row :gutter="20">
          <a-col>
            <div>
              <div style="width: calc(200%);text-align: center">
                <a-row :gutter="10">
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">外部评级</span>
                  </a-col>
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      内部等级
                    </span>
                  </a-col>
                  <a-col :span="2" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">操作</span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; width: calc(230%);"
              v-for="(scoreResult, index) in wwForm"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question" >
                <div v-if="index == 0" style="height: 5px;"></div>
                <a-row :gutter="5">
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input
                          controls-position="right"
                          v-model="scoreResult.maxLevel"
                          :step="1"
                          :max-length="20"
                          style="width: 200px; height: 30px"
                          :disabled="wwEdit"
                          type="text"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-select
                          placeholder="请选择等级"
                          v-model="scoreResult.creditLevel"
                          style="width: 200px; height: 30px"
                          :disabled="wwEdit"
                        >
                          <a-select-option
                            v-for="item in objectList"
                            :value="item.text"
                            :key="item.text"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" style="margin-left: -30px; margin-top: 10px">
                    <a-tooltip placement="topLeft">
                      <img
                        src="./images/add.png"
                        style="width: 20px; height: 20px"
                        @click="addWw"
                        v-if="!wwEdit"
                      />
                    </a-tooltip>
                    <a-tooltip placement="topLeft" style="margin-left: 10px">
                      <img
                        src="./images/delete.png"
                        style="width: 20px; height: 20px; margin-top: -1px"
                        @click="removeWw(scoreResult)"
                        v-if="index != 0 && wwEdit == false"
                      />
                    </a-tooltip>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
        </a-row>
        <div style="margin-top: 10px, margin-left: 300px, right: 0">
            <a-button @click="handleSubmitSetting(wwForm, 6)" v-if="!wwEdit">
                提交
            </a-button>
            <a-button @click="handleWwEdit" v-else>
                编辑
            </a-button>
        </div>
      </a-card>
    </div>

  <div class="shareholder" style="display: flex;">
    <a-card style="margin-top: 10px; width: 50%">
        <div style="margin-top: -10px; margin-bottom: 10px; font-weight: bold;">Z'‘Score评分转换规则</div>
        <a-row :gutter="20">
          <a-col>
            <div style=" width: 145%">
              <div>
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px;">最小值</span>
                  </a-col>
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">最大值</span>
                  </a-col>
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      内部等级
                    </span>
                  </a-col>
                  <a-col :span="2" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      操作
                    </span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; width: calc(160%);"
              v-for="(scoreResult, index) in zForm"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question" >
                <div v-if="index == 0" style="height: 5px;"></div>
                <a-row :gutter="5">
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.minLevel"
                          :step="1"
                          :max-length="20"
                          style="width: 150px; height: 30px"
                          :disabled="index == 0 ? true : false || zEdit == true"
                          :style="index == 0 ? 'background: #f3f3f3;' : ''"
                          max="10000" min="0"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.maxLevel"
                          :step="1"
                          :max-length="20"
                          style="width: 150px; height: 30px"
                          max="10000" min="0"
                          :disabled="
                            index == zForm.length - 1 ? true : false || zEdit == true
                          "
                          :style="
                            index == zForm.length - 1
                              ? 'background: #f3f3f3;'
                              : ''
                          "
                          @change="copyMax(scoreResult, index)"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-select
                          placeholder="请选择等级"
                          v-model="scoreResult.creditLevel"
                          style="width: 150px; height: 30px"
                          :disabled="zEdit"
                        >
                          <a-select-option
                            v-for="item in objectList"
                            :value="item.text"
                            :key="item.text"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" style="margin-top: 10px; margin-left: 10px">
                    <a-tooltip placement="topLeft">
                      <template #title>新增分值区间</template>
                      <img
                        src="./images/add.png"
                        style="width: 20px; height: 20px"
                        @click="addScoreResult"
                        v-if="index != zForm.length - 1 && zEdit == false"
                      />
                    </a-tooltip>
                    <a-tooltip placement="topLeft" style="margin-left: 10px">
                      <template #title>删除分值区间</template>
                      <img
                        src="./images/delete.png"
                        style="width: 20px; height: 20px; margin-top: -2px"
                        @click="removeScoreResult(scoreResult)"
                        v-if="index != zForm.length - 1 && index != 0 && zEdit == false"
                      />
                    </a-tooltip>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
        </a-row>
        <div style="margin-top: 10px,">
            <a-button @click="checkDate" v-if="!zEdit">
                提交
            </a-button>
            <a-button @click="handleZEdit" v-else>
                编辑
            </a-button>
        </div>
        <a-row style="color: red; margin-top: 15px;margin-left: 28px;">
            <a-col>
              注：1、分值区间的开始最小值必须等于上一个结束的最大值，例如：10 至
              60 ，60 至 90，90 至 100
            </a-col>
            <a-col style="padding-left: 28px">
              2、每条分值区间包小不包大，及 最小值 &lt;= 值 &lt; 最大值
            </a-col>
            <a-col style="padding-left: 28px">
              3、分值区间第一条不能填写最小值
            </a-col>
            <a-col style="padding-left: 28px">
              4、分值区间最后一条不能填写最大值
            </a-col>
          </a-row>
    </a-card>

      <a-card style="margin-top: 10px; width: 50%">
        <div style="margin-top: -10px; margin-bottom: 10px; font-weight: bold;">S&P评分转换规则</div>
        <a-row :gutter="20">
          <a-col>
            <div>
              <div style="width: calc(200%);">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">外部评级</span>
                  </a-col>
                  <a-col :span="5" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      内部等级
                    </span>
                  </a-col>
                  <a-col :span="2" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">操作</span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; width: calc(220%);"
              v-for="(scoreResult, index) in spForm"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question" >
                <div v-if="index == 0" style="height: 5px;"></div>
                <a-row :gutter="5">
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input
                          controls-position="right"
                          v-model="scoreResult.maxLevel"
                          :step="1"
                          :max-length="20"
                          style="width: 200px; height: 30px"
                          :disabled="spEdit"
                          max="10000" min="0"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-select
                          placeholder="请选择等级"
                          v-model="scoreResult.creditLevel"
                          style="width: 200px; height: 30px"
                          :disabled="spEdit"
                        >
                          <a-select-option
                            v-for="item in objectList"
                            :value="item.text"
                            :key="item.text"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" style="margin-left: -30px; margin-top: 10px">
                    <a-tooltip placement="topLeft">
                      <img
                        src="./images/add.png"
                        style="width: 20px; height: 20px"
                        @click="addSp"
                        v-if="!spEdit"
                      />
                    </a-tooltip>
                    <a-tooltip placement="topLeft" style="margin-left: 10px">
                      <img
                        src="./images/delete.png"
                        style="width: 20px; height: 20px; margin-top: -1px"
                        @click="removeSp(scoreResult)"
                        v-if="index != 0 && spEdit == false"
                      />
                    </a-tooltip>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
        </a-row>
        <div style="margin-top: 10px, margin-left: 300px, right: 0">
            <a-button @click="handleSubmitSetting(spForm,5)" v-if="!spEdit">
                提交
            </a-button>
            <a-button @click="handleSpEdit" v-else>
                编辑
            </a-button>
        </div>
      </a-card>
  </div>

  </div>
</template>
<script>
import mixin from './mixin'
import { page, update } from './api'

export default {
  mixins: [mixin],
  data() {
    return {
      friskForm: [],
      fitchForm: [],
      zForm: [],
      moodyForm: [],
      spForm: [],
      wwForm: [],
      friskEdit: true,
      fitchEdit: true,
      zEdit: true,
      moodyEdit: true,
      spEdit: true,
      wwEdit: true,
      tableData: [],
      visible: false,
      disabled: false,
      objectList: [
        {
          text: 'AAA',
          value: '1',
        },
        {
          text: 'AA+',
          value: '2',
        },
        {
          text: 'AA',
          value: '3',
        },
        {
          text: 'AA-',
          value: '4',
        },
        {
          text: 'A+',
          value: '5',
        },
        {
          text: 'A',
          value: '6',
        },
        {
          text: 'A-',
          value: '7',
        },
        {
          text: 'BBB',
          value: '8',
        },
        {
          text: 'BB',
          value: '9',
        },
        {
          text: 'B',
          value: '10',
        },
      ],
    }
  },
  components: {

  },
  mounted() {
    this._getPage()
  },
  methods: {
    _getPage() {
      // const { current, pageSize } = this.pageData
      // const formData = {
      //   size: pageSize,
      //   current,
      // }
      page(2).then(({ data }) => {
        this.index = this.index+1;
        this.goToSetting(data)
      })
      page(1).then(({ data }) => {
        this.getFrisk(data)
      })
      page(3).then(({ data }) => {
        this.getFitchk(data)
      })
      page(4).then(({ data }) => {
        this.getMoody(data)
      })
      page(5).then(({ data }) => {
        this.getSp(data)
      })
      page(6).then(({ data }) => {
        this.getWw(data)
      })
    },
    getFrisk(date) {
      this.friskForm = []
      if (date.length > 0) {
        this.friskForm = date
      } else {
        this.friskForm.push(
        {
          maxLevel: null,
          creditLevel: null,
        },
        ) 
      }   
    },
    getFitchk(date){
      this.fitchForm = []
      if (date.length > 0) {
        this.fitchForm = date
      } else {
        this.fitchForm.push(
        {
          maxLevel: null,
          creditLevel: null,
        },
        ) 
      }  
    },
    getMoody(date){
      this.moodyForm = []
      if (date.length > 0) {
        this.moodyForm = date
      } else {
        this.moodyForm.push(
        {
          maxLevel: null,
          creditLevel: null,
        },
        ) 
      }  
    },
    getSp(date){
      this.spForm = []
      if (date.length > 0) {
        this.spForm = date
      } else {
        this.spForm.push(
        {
          maxLevel: null,
          creditLevel: null,
        },
        ) 
      }  
    },
    getWw(date){
      this.wwForm = []
      if (date.length > 0) {
        this.wwForm = date
      } else {
        this.wwForm.push(
        {
          maxLevel: null,
          creditLevel: null,
        },
        ) 
      }  
    },
    // 设置分值区间
    goToSetting(date) {
      this.zForm = []
      if (date.length > 0) {
        this.zForm = date
      } else {
        this.zForm.push(
        {
          minLevel: null,
          maxLevel: null,
          creditLevel: null,
        },
        {
          minLevel: null,
          maxLevel: null,
          creditLevel: null,
        },
        {
          minLevel: null,
          maxLevel: null,
          creditLevel: null,
        },
        ) 
      }   
    },

    // 提交
    checkDate(){
      for (var i = 0; i < this.zForm.length; i++) {
          if (i == 0) {
            if (
              this.zForm[i].maxLevel == null ||
              this.zForm[i].maxLevel == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最大值补充完整',
              })
              return false
            }
          } else if (i == this.zForm.length - 1) {
            if (
              this.zForm[i].minLevel == null ||
              this.zForm[i].minLevel == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最小值补充完整',
              })
              return false
            }
            // 校验最后一行最小值是否与上一行最大值相同
            if (
              this.zForm[i].minLevel !=
              this.zForm[i - 1].maxLevel
            ) {
              this.$notification.warning({
                message: '提示',
                description:
                  '第' + (i + 1) + '行最小值必须等于第' + i + '行的最大值',
              })
              return false
            }
          } else {
            if (
              this.zForm[i].minLevel == null ||
              this.zForm[i].minLevel == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最小值补充完整',
              })
              return false
            }
            if (
              this.zForm[i].maxLevel == null ||
              this.zForm[i].maxLevel == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最大值补充完整',
              })
              return false
            }
            // 校验本行最小值必须大于最大值
            if (
              parseInt(this.zForm[i].minLevel) >=
              parseInt(this.zForm[i].maxLevel)
            ) {
              this.$notification.warning({
                message: '提示',
                description: '第' + (i + 1) + '行最小值必须小于最大值',
              })
              return false
            }
            // 校验本行最小值是否与上一行最大值相同
            if (
              this.zForm[i].minLevel !=
              this.zForm[i - 1].maxLevel
            ) {
              this.$notification.warning({
                message: '提示',
                description:
                  '第' + (i + 1) + '行最小值必须等于第' + i + '行的最大值',
              })
              return false
            }
          }
          // 校验等级是否填写
          if (
            this.zForm[i].creditLevel == null ||
            this.zForm[i].creditLevel == undefined
          ) {
            this.$notification.warning({
              message: '提示',
              description: '请将第' + (i + 1) + '行的内部等级补充完整',
            })
            return false
          }
        }
        this.handleSubmitSetting(this.zForm,2);
    },
    async handleSubmitSetting(form, type) {
      if(type != 2){
        for (var i = 0; i < form.length; i++) {
          if(form[i].maxLevel == null || form[i].maxLevel == undefined){
            this.$notification.warning({
              message: '提示',
              description: '请将第' + (i + 1) + '行外部评级补充完整',
            })
            return false
          }
          if (form[i].creditLevel == null || form[i].creditLevel == undefined) {
            this.$notification.warning({
            message: '提示',
              description: '请将第' + (i + 1) + '行的内部等级补充完整',
            })
            return false
          }
        }
      }
      const sunmitTable = {
        creditRatingConversions: form,
        type: type,
      }
      await update(sunmitTable);
      this.$message.success('成功')
      this.friskEdit = true
      this.fitchEdit = true
      this.zEdit = true
      this.spEdit = true
      this.wwEdit = true
      this.moodyEdit = true
      this._getPage()
    },
    async handleFriskEdit(){
      this.friskEdit = false
    },
    async handleFitchEdit(){
      this.fitchEdit = false
    },
    async handleZEdit(){
      this.zEdit = false
    },
    async handleSpEdit(){
      this.spEdit = false
    },
    async handleWwEdit(){
      this.wwEdit = false
    },
    async handleMoodyEdit(){
      this.moodyEdit = false
    },
    // 新增一行
    addScoreResult() {
      this.zForm.push({
        minLevel: null,
        maxLevel: null,
        creditLevel: null,
      })
    },
    // 删除分值区间
    removeScoreResult(item) {
      let index = this.zForm.indexOf(item)
      if (index !== -1) {
        this.zForm.splice(index, 1)
      }
    },
    
    // 新增一行
    addFrisk() {
      this.friskForm.push({
        maxLevel: null,
        creditLevel: null,
      })
    },
    // 删除分值区间
    removeFrisk(item) {
      let index = this.friskForm.indexOf(item)
      if (index !== -1) {
        this.friskForm.splice(index, 1)
      }
    },

    //上一行最大值=下一行最小值
    copyMax(scoreResult, index) {
      let i = 0
      const nextIndex = index + 1
      for (; i < this.zForm.length; i++) {
        if (i === nextIndex) {
          this.zForm[i].minLevel = scoreResult.maxLevel
        }
      }
    },

    addSp() {
      this.spForm.push({
        maxLevel: null,
        creditLevel: null,
      })
    },
    removeSp(item) {
      let index = this.spForm.indexOf(item)
      if (index !== -1) {
        this.spForm.splice(index, 1)
      }
    },

    addWw() {
      this.wwForm.push({
        maxLevel: null,
        creditLevel: null,
      })
    },
    removeWw(item) {
      let index = this.wwForm.indexOf(item)
      if (index !== -1) {
        this.wwForm.splice(index, 1)
      }
    },

    addFitch() {
      this.fitchForm.push({
        maxLevel: null,
        creditLevel: null,
      })
    },
    removeFitch(item) {
      let index = this.fitchForm.indexOf(item)
      if (index !== -1) {
        this.fitchForm.splice(index, 1)
      }
    },

    addMoody() {
      this.moodyForm.push({
        maxLevel: null,
        creditLevel: null,
      })
    },
    removeMoody(item) {
      let index = this.moodyForm.indexOf(item)
      if (index !== -1) {
        this.moodyForm.splice(index, 1)
      }
    },

  },
}
</script>
<style lang="less" scoped>
.estimate-list {
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.estimate-question {
  width: calc(100% - 140px);
  height: 50px;
}
.estimate-button {
  width: 50px;
  height: 40px;
  // line-height: 36px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
/deep/ .editable-row-operations a {
  margin-right: 8px;
}
/deep/ .margin-top-20 {
  margin-top: 20px;
}
/deep/ .width-100 {
  width: 100%;
}
</style>
